export default __webpack_public_path__ + "static/media/banner.a450a0af.webp";